
<app-right-side></app-right-side>
<app-header></app-header>
<app-team-header></app-team-header>
<div *ngIf="isLoaderVisible" class="preloader js-preloader">
    <img src="../../../assets/img/loader.webp">
</div>
<div class="container">
    <div class="row">
        <div class="col col-xl-9 order-xl-2 col-lg-9 order-lg-2 col-md-12 order-md-1 col-sm-12 col-12">
            <div class="ui-block">
                <div class="ui-block-title">
                    <h6 class="title">Matches</h6>
                </div>
                <div class="ui-block-content">
                    <form class="content" [formGroup]="matchForm" (ngSubmit)="addMatch()">
                        <div class="row">
                            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label">Host Team Name <span style="color: red;"> *
                                        </span></label>
                                    <input disabled type="text" value="{{countryData.name}}" class="form-control" />
                                </div>
                                <div class="form-group">
                                    <label class="control-label">Visitor Team Name <span style="color: red;"> *
                                        </span></label>
                                    <select name="team1" id="visitingTeam" formControlName="visitingTeam"
                                        class="nice-select filter-input mar-top-0 form-control" tabindex="0"
                                        [ngClass]="{ 'is-invalid': submitted && f.visitingTeam.errors }">
                                        <option class="list option selected focus" *ngFor="let country of countryList"
                                            [value]="country.id">{{country.name}}</option>
                                    </select>
                                    <div *ngIf="submitted && f.visitingTeam.errors" class="invalid-feedback">
                                        <div *ngIf="f.visitingTeam.errors.required">Team name is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-lg-6 col-md-6 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label"> Host Team Score <span style="color: red;"> *
                                        </span></label>
                                    <input type="text" formControlName="hostScore" class="form-control"
                                        (keypress)="numberOnly($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.hostScore.errors }" />
                                    <div *ngIf="submitted && f.hostScore.errors" class="invalid-feedback">
                                        <div *ngIf="f.hostScore.errors.required">Host Team Score is required</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label">Visiting Team Score <span style="color: red;"> *
                                        </span></label>
                                    <input type="text" formControlName="visitingScore" class="form-control"
                                        (keypress)="numberOnly($event)"
                                        [ngClass]="{ 'is-invalid': submitted && f.visitingScore.errors }" />
                                    <div *ngIf="submitted && f.visitingScore.errors" class="invalid-feedback">
                                        <div *ngIf="f.visitingScore.errors.required">Visiting Team Score is required
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div class="form-group">
                                    <label class="control-label">Match Summary </label>
                                    <textarea class="form-control" name="matchSummary" formControlName="matchSummary"
                                        placeholder="Match Summary"
                                        [ngClass]="{ 'is-invalid': submitted && f.matchSummary.errors }"></textarea>
                                    <div *ngIf="submitted && f.matchSummary.errors" class="invalid-feedback">
                                        <div *ngIf="f.matchSummary.errors.required">Summary is required</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <button class="btn btn-primary btn-lg full-width">
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div
            class="col col-xl-3 order-xl-1 col-lg-3 order-lg-1 col-md-12 order-md-2 col-sm-12 col-12 responsive-display-none">
            <div class="ui-block">
                <div class="your-profile">
                    <div id="accordion" role="tablist" aria-multiselectable="true">
                        <div class="card">
                            <div class="card-header" role="tab" id="headingOne">
                                <h6 class="mb-0">
                                    <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne"
                                        aria-expanded="true" aria-controls="collapseOne">
                                        Dashboard Settings
                                        <svg class="olymp-dropdown-arrow-icon">
                                            <use xlink:href="#olymp-dropdown-arrow-icon"></use>
                                        </svg>
                                    </a>
                                </h6>
                            </div>

                            <div id="collapseOne" class="collapse show" role="tabpanel" aria-labelledby="headingOne">
                                <ul class="your-profile-menu ">
                                    <li class="active ">
                                        <a routerLink="/team-dashboard" [queryParams]="{ 'id': countryData.id} "
                                            routerLinkActive="active ">News/Blogs</a>
                                    </li>
                                    <li>
                                        <a routerLink="/dashboard-media" [queryParams]="{ 'id': countryData.id} "
                                            routerLinkActive="active ">Photos/Videos</a>
                                    </li>
                                    <li>
                                        <a routerLink="/dashboard-matches" [queryParams]="{ 'id': countryData.id} "
                                            routerLinkActive="active ">Add Matches</a>
                                    </li>
                                    <li>
                                        <a routerLink="/dashboard-add-club" [queryParams]="{ 'id': countryData.id} "
                                            routerLinkActive="active ">Add Club</a>
                                    </li>
                                    <li>
                                        <a routerLink="/dashboard-leagues" [queryParams]="{ 'id': countryData.id} "
                                            routerLinkActive="active ">Add Leagues</a>
                                    </li>
                                    <li>
                                        <a routerLink="/dashboard-add-media" [queryParams]="{ 'id': countryData.id} "
                                            routerLinkActive="active ">Add Media</a>
                                    </li>
                                    <li>
                                        <a routerLink="/dashboard-player" [queryParams]="{ 'id': countryData.id} "
                                            routerLinkActive="active ">Add Player</a>
                                    </li>
                                    <li>
                                        <a routerLink="/dashboard-referee" [queryParams]="{ 'id': countryData.id} "
                                            routerLinkActive="active ">Add Referee</a>
                                    </li>
                                    <li>
                                        <a routerLink="/dashboard-coach" [queryParams]="{ 'id': countryData.id} "
                                            routerLinkActive="active ">Add Coach</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>